import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import Header from '../../BaseComponents/Header';
import FotterMain from '../../BaseComponents/FotterMain';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { baseURL, getCategoryListExport } from '../../../networkCalls';
import CategoryDisplayCel from '../../BaseComponents/HomeCels/CategoryDisplayCel';
import SEO from '../../BaseComponents/SEO';

const promise = getCategoryListExport();
const ExportsLP = () => {

  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [value1, setValue1] = useState('1');
  const handle1Change = (event, newValue) => {
    setValue1(newValue);
  };
  const [catlist, setCatlist] = React.useState([]);


  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    promise.then(data => {
        setCatlist(data?.CategoryListArray);
        setLoading(false);
    });
  }, [catlist]);

  const toTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    toTop();
  }, []);

  return (
    <>
     <SEO
        title="Honda India Power Products | Honda Exports"
        description="Honda India is a 100% export oriented company. A wide range of Honda products are manufactured at its factory in Greater Noida, India."
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/exports"
        type='Website' />
      <Header />
      <div className="post-view__header post-header post-header--has-image ">
        <div className="post-header__image post-header__image-export"></div>
        {/* <div className="post-header__image" style="background-image: url('https://red-parts.react.themeforest.scompiler.ru/themes/red/images/posts/post-1.jpg);"></div> */}
        <div className="post-header__body md-mt-5 md-mb-5 mt-0 mb-0">
          <div className="post-header__categories mt-5">
            <div className="post-header__categories-list mt-5 mb-5">
              <div className="post-header__categories-item mb-3 mt-5 d-none d-md-block">&nbsp;</div>
            </div>
          </div>
          <h3 className="post-header__title mt-5 mb-5 d-none d-md-block">&nbsp;</h3>
          <div className="post-header__meta  mt-5">
            <ul className="post-header__meta-list mt-5 d-none d-md-block">
              <li className="post-header__meta-item mt-5"></li>
            </ul>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12  m-auto'>
            <div className='post-view__body card rounded-0 border-0'>
              {/* content here */}
              <div className="cm-content prscot">
                <div className='p-4'>

                <h4 className='d-block m-0 fw-bold text-uppercase mb-3 mt-2'>
                  <span className='txtred'>EXPORT</span> <span className='txtdgray'>ACTIVITIES</span>
                </h4>
                <p className='f18'>To expand our markets, we introduced Power Products in Overseas Markets and have established the image of “Honda” with Made in India.</p>
                <p className='f14'>Currently, our products are being sold to more than 35 countries across the globe and our 7.0 kVA generator has established its good image due to quality, performance, technology ( Fuel Injection System ) in USA, Europe and other developed markets.</p>
                <p className='f14'>This model is meeting the stringent air & noise pollution norms applicable of India, USA and other developed nations and this is the first “Fuel Injection Based” generator (in its category) introduced by Honda in the world market in 2014.</p>
                <p className='f14'>Due to our overseas performance, Central & State Govt. recognized it through National & State level awards and Certificate of Recognition from time to time.</p>
              
                </div> 
                <hr />
                <h4 className='d-block m-0 fw-bold text-uppercase mb-3 mt-2'>
                  <span className='txtred'>EXPORT</span> <span className='txtdgray'>PRODUCTS</span>
                </h4>
                {catlist && catlist?.length > 0 ? <><CategoryDisplayCel catlist={catlist} exportval='Y' /></> : null}
                <hr />
                <div className='row'>
                  <div className='col-12'>
                    <h4 className='d-block m-0 fw-bold text-uppercase text-start mb-3 mt-4'>
                      <span className='txtred'>DISTRIBUTION</span> <span className='txtdgray'>CHANNEL</span>
                    </h4>
                    <p className='f14'>Our products are available through Global Honda Distribution Network and each country across the globe, Honda Power Products Distribution network is available.<br />If there is no distributor or our above product is not available through them, then please do write to us at customer.support@hipp.co.in</p>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                      <TabContext value={value1}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <TabList
                            onChange={handle1Change}
                            variant='scrollable'
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            TabIndicatorProps={{
                              style: {
                                backgroundColor: '#CB1100'
                              },
                            }}
                            aria-label="">
                            <Tab label="ASIA & OCEANIA" value="1" />
                            <Tab label="NORTH AMERICA" value="2" />
                            <Tab label="JAPAN" value="3" />
                            <Tab label="MIDDLE EAST" value="5" /> 
                            <Tab label="AFRICA" value="6" /> 
                            <Tab label="EUROPE" value="7" /> 
                            <Tab label="SOUTH AMERICA" value="4" />
                          </TabList>
                        </Box>
                        <TabPanel value="1">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img  src={`${baseURL}images/map-1-v1.jpg`}  alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#9170ff'}} /></div>
                                <div className='ms-2'>NEPAL</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#ff9744'}} /></div>
                                <div className='ms-2'>SRI LANKA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#fffd44'}} /></div>
                                <div className='ms-2'>BANGLADESH</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#6fbfff'}}  /></div>
                                <div className='ms-2'>INDONESIA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#db44ff'}}  /></div>
                                <div className='ms-2'>SOUTH KOREA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#70bfff'}} /></div>
                                <div className='ms-2'>PHILIPPINES</div>
                              </div>
                              <div className='d-flex align-items-center mb-2' >
                                <div><AddLocationAltIcon style={{color:'#6860FF'}} /></div>
                                <div className='ms-2'>MALAYSIA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#D4FF29'}}  /></div>
                                <div className='ms-2'>HONG KONG</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#E56BFD'}} /></div>
                                <div className='ms-2'>SINGAPORE</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon  style={{color:'#FE2555'}} /></div>
                                <div className='ms-2'>TAIWAN</div>
                              </div>
                          
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#f15f75'}} /></div>
                                <div className='ms-2 text-uppercase'>Australia</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#a0ad3c'}} /></div>
                                <div className='ms-2 text-uppercase'>Vietnam</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#3c9cad'}} /></div>
                                <div className='ms-2 text-uppercase'>New Zealand</div>
                              </div>
                            </div>
                          </div>
                          {/* {isLoaded ? <><GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={5}
                            onLoad={onLoad}
                            onUnmount={onUnmount}
                          >
                            {markers.map(({ id, name, position }) => (
                              <Marker
                                key={id}
                                position={position}
                                onClick={() => handleActiveMarker(id)}
                              >
                                {activeMarker === id ? (
                                  <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                    <div>{name}</div>
                                  </InfoWindow>
                                ) : null}
                              </Marker>
                            ))}
                          </GoogleMap></> : <></>} */}
                        </TabPanel>
                        <TabPanel value="2">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img src={`${baseURL}images/map-2.png`} alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#9EFF3F'}} /></div>
                                <div className='ms-2'>USA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#81A3FF'}} /></div>
                                <div className='ms-2'>CANADA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#B139FF'}} /></div>
                                <div className='ms-2'>MEXICO</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#46FBFF'}}  /></div>
                                <div className='ms-2'>HAITI</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#FF504E'}}  /></div>
                                <div className='ms-2'>GUATEMALA</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#3c9cad'}}  /></div>
                                <div className='ms-2 text-uppercase'>Dominican Republic</div>
                              </div>
                              
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel value="3">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img src={`${baseURL}images/map-japan.jpg`} alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                             <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#43c74c'}} /></div>
                                <div className='ms-2 text-uppercase'>Japan</div>
                              </div>
                              {/* <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#bfb576'}} /></div>
                                <div className='ms-2 text-uppercase'>UAE</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#c743bc'}} /></div>
                                <div className='ms-2 text-uppercase'>South Africa</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#c75f43'}} /></div>
                                <div className='ms-2 text-uppercase'>Belgium</div>
                              </div> */}
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel value="5">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img src={`${baseURL}images/map-uae.jpg`} alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                            
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#bfb576'}} /></div>
                                <div className='ms-2 text-uppercase'>UAE</div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel value="6">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img src={`${baseURL}images/map-south-africe.jpg`} alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                            
                            <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#c743bc'}} /></div>
                                <div className='ms-2 text-uppercase'>South Africa</div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel value="7">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img src={`${baseURL}images/map-belgium.jpg`} alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                            <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#c75f43'}} /></div>
                                <div className='ms-2 text-uppercase'>Belgium</div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>

                      
                        <TabPanel value="4">
                          <div className='row mt-4'>
                            <div className='col-12 col-lg-10'>
                              <img src={`${baseURL}images/map-4.png`} alt="" className='img-fluid' />
                            </div>
                            <div className='col-12 col-lg-2 f14'>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#3c9cad'}} /></div>
                                <div className='ms-2 text-uppercase'>Argentina</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#ad673c'}} /></div>
                                <div className='ms-2 text-uppercase'>Bolivia</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#3B78FE'}} /></div>
                                <div className='ms-2 text-uppercase'>BRAZIL</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#FF3B43'}} /></div>
                                <div className='ms-2 text-uppercase'>CHILE</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#6e6b69'}} /></div>
                                <div className='ms-2 text-uppercase'>Ecuador</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#B63EFF'}} /></div>
                                <div className='ms-2 text-uppercase'>PERU</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#0bc840'}} /></div>
                                <div className='ms-2 text-uppercase'>Uruguay</div>
                              </div>
                              <div className='d-flex align-items-center mb-2'>
                                <div><AddLocationAltIcon style={{color:'#bfb576'}} /></div>
                                <div className='ms-2 text-uppercase'>Venezuela</div>
                              </div>
                              

                              
                            
                             
                             
                             
                            </div>
                          </div>
                        </TabPanel>
                      </TabContext>
                    </Box>
                  </div>
                </div>
                <hr />
                <div className='row'>
                  <div className='col-12'>
                    <h4 className='d-block m-0 fw-bold text-uppercase text-start mb-3 mt-4'>
                      <span className='txtred'>WRITE TO</span> <span className='txtdgray'>US</span>
                    </h4>
                    <p className='f14'>For any kind of Overseas business inquiry, please write a mail with your name, complete address, website details, E-Mail ID to customer.support@hipp.co.in we will revert to your inquiry soon.</p>

                  </div>
                </div>
              </div>
              {/* content here */}

            </div>
          </div>
        </div>
      </div>
      <div style={{ clear: 'both', height: '40px' }}></div>
      <FotterMain />
    </>
  )
}

export default ExportsLP
